import { call, delay, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { ForgotPasswordType, ResendVerificationCodeType, VerifyProviderEmailType } from "./types";
import { confirmSignUp, resendConfirmationCode, resetUserPassword, updateUserAttributes, updateUserPassword } from "./ProviderAPI";
import { VerifyEmailResponseType } from "./types";
import { providerActions } from "./reducer";
import { getCurrentAuthUser } from "./ProviderAPI";
import { toastError, toastSuccess } from "../../Methods/Helpers/ToastHelper";
import { APIResponseType } from "../../Services/Models/Async/AsyncModel";
  
function* handleVerifyEmail(action: PayloadAction<VerifyProviderEmailType>): any{
    try{
      let response: VerifyEmailResponseType = yield call(confirmSignUp, action.payload);
      if(response.success){
        if(action.payload.verifyFor === "register"){
          yield delay(3000);
          let userData = yield call(getCurrentAuthUser);
          if(userData.success){
            yield put(providerActions.verifyEmailSuccess(userData));
          }else{
           yield call(toastError, userData.message);
          }
        }else{
          yield call(toastSuccess, "Email verified successfully, please login to continue.");
          yield put(providerActions.logout());
        }
      }else{
        if(response.code === "NotAuthorizedException"){
          yield put(providerActions.verifyEmailFailed("Failed to verify email"));
         yield call(toastError, response.message);
        }else{
          yield put(providerActions.verifyEmailFailed("Failed to verify email"));  
          yield call(toastError, "Unable to verify email");
        }
      }
    }catch(error: any){
      yield call(toastError, error.message);
      yield put(providerActions.verifyEmailFailed("Failed to verify email"));
    }
}
  
function* handleResendEmailVerificationCode(action: PayloadAction<ResendVerificationCodeType>): any{
    try{
      const response: any = yield call(resendConfirmationCode, action.payload);
      if(response.success){
        yield call(toastSuccess, response.message);
      }else{
        if(response.code === "LimitExceededException"){
          yield call(toastError, "Attempt limit exceeded, please try after some time.");
        }else{
          yield call(toastError, response.message);
        }
      }
      yield put(providerActions.resendEmailVerificationCodeRequestComplete());
    }catch(error: any){
      yield call(toastError, error.message);
      yield put(providerActions.resendEmailVerificationCodeRequestComplete());
    }
}

function* updateProviderProfileAttributesFlow({ payload }: any){
  try {
    const response: APIResponseType<any> = yield call(updateUserAttributes, payload);
    if(response.success){
      yield put(providerActions.updateProviderProfileSuccess(response.data));
      yield call(toastSuccess, "Provider info updated successfully.")
    }else{
      yield put(providerActions.updateProviderProfileFail());
      yield call(toastError, response.message);
    }
    yield put(providerActions.updateProviderProfileSuccess(response.data));
  } catch (err: any) {  
    yield call(toastError, err.message);
    yield put(providerActions.updateProviderProfileFail());
  }
}

function* resetPasswordFlow({ payload }: any){
  try {
    const response: APIResponseType<any> = yield call(updateUserPassword, payload);
    if(response.success){
      yield put(providerActions.resetPasswordSuccess());
      yield call (toastSuccess, response.message);
    } else {
      if(response.code === "NotAuthorizedException"){
        yield call(toastError, "Current password is invalid");
      }else if(response.code === "InvalidPasswordException"){
        yield call(toastError, "Incorrect new password, Please check the password policy");
      }
      yield put(providerActions.resetPasswordFail());
    }
  } catch (err: any) {
   yield call(toastError, err.message);
    yield put(providerActions.resetPasswordFail());
  }
}

function* updateDashboardFlow({ payload }: any){
  try {
    // const response: APIResponseType<any> = yield call(updateProviderDashboardAPI, payload);
    yield put(providerActions.updateDashboardSuccess(payload));
  } catch (error: any) {
    yield call(toastError, error.message);
    yield put(providerActions.updateDashboardFail(error.message));
  }
}

function* handleForgotPassword(action: PayloadAction<ForgotPasswordType>): any{
  try{
    const response: any = yield call(resetUserPassword, action.payload);
    if(response.success){
      yield put(providerActions.forgotPasswordSuccess());
      yield call(toastSuccess, "Password reset successfully");
    }else{
      yield put(providerActions.forgotPasswordFailed());
      yield call(toastError, response.message);
    }
  }catch(error: any){
    yield call(toastError, error.message);
    yield put(providerActions.forgotPasswordFailed());
  }
}

function* ProviderSaga() {
    yield takeLatest(providerActions.verifyEmail.type, handleVerifyEmail);
    yield takeLatest(providerActions.resendEmailVerificationCodeRequest.type, handleResendEmailVerificationCode);
    yield takeLatest(providerActions.updateProviderProfileRequest.type, updateProviderProfileAttributesFlow);
    yield takeLatest(providerActions.resetPasswordRequest.type, resetPasswordFlow);
    yield takeLatest(providerActions.updateDashboardRequest.type, updateDashboardFlow);
    yield takeLatest(providerActions.forgotPassword.type, handleForgotPassword);
}
  
export default ProviderSaga;